import { ShieldCheck, MessagesSquare, ArrowLeftRight, BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/ui-bits";

const ITEMS = [
  {
    icon: ShieldCheck,
    title: "RELIABLE",
    desc: "Dependable transportation solutions built around your requirements.",
  },
  {
    icon: MessagesSquare,
    title: "RESPONSIVE",
    desc: "Clear communication from pickup through delivery.",
  },
  {
    icon: ArrowLeftRight,
    title: "FLEXIBLE",
    desc: "Transportation options that adapt to your shipment needs.",
  },
  {
    icon: BadgeCheck,
    title: "PROFESSIONAL",
    desc: "A structured approach to transportation and service.",
  },
];

const TrustStrip = () => {
  return (
    <section data-testid="trust-strip" aria-label="Our commitments" className="border-y border-[#e5e7eb] bg-white">
      <div className="container-30 grid sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((item, i) => (
          <Reveal
            key={item.title}
            delay={i * 0.08}
            className={`border-[#e5e7eb] px-2 py-8 sm:px-8 lg:py-10 ${
              i > 0 ? "border-t sm:border-t-0" : ""
            } ${i % 2 === 1 ? "sm:border-l" : ""} ${i > 0 ? "lg:border-l" : ""} ${i === 2 ? "sm:border-t lg:border-t-0" : ""} ${i === 3 ? "sm:border-t lg:border-t-0" : ""}`}
          >
            <div data-testid={`trust-item-${i + 1}`}>
              <item.icon className="h-6 w-6 text-[#ff6a00]" strokeWidth={1.75} aria-hidden="true" />
              <h3 className="mt-5 text-sm font-bold tracking-[0.16em] text-[#191c1e]">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#5f666d]">{item.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default TrustStrip;
